import { RefObject, useMemo, useState, useSyncExternalStore } from 'react';

function useHeightObserver(ref: RefObject<HTMLElement>): number {
  const [height, setHeight] = useState<number>(0);

  function subscribe(callback: (e: Event) => void) {
    const resizeObserver = new ResizeObserver(([entry]) => {
      setHeight(entry.contentBoxSize[0].blockSize);
      callback(null);
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect();
  }

  const dimensions = useSyncExternalStore(
    subscribe,
    () => height,
    () => height,
  );

  return useMemo(() => dimensions, [dimensions]);
}

export { useHeightObserver };
